import { version, homepage } from '../../package.json';

export const environment = {

    get APP_URL() {
        return process.env.REACT_APP_APP_URL;
    },

    get SITE_URL() {
        return process.env.REACT_APP_SITE_URL;
    },

    get APP_VERSION() {
        return version;
    },

    get APP_BASE_NAME() {
        return homepage;
    },

    get API_URL() {
        return process.env.REACT_APP_API_URL;
    },

    get WEBAPI_URL() {
        return process.env.REACT_APP_WEBAPI_URL;
    },

    get MIXPANEL_API_KEY() {
        return process.env.REACT_APP_MIXPANEL_API_KEY;
    },

    get BLIP_API_KEY() {
        return process.env.REACT_APP_BLIP_API_KEY;
    },

    get BLIP_CUSTOM_URL() {
        return process.env.REACT_APP_BLIP_CUSTOM_URL;
    },

    get IS_PRODUCTION() {
        return process.env.REACT_APP_IS_PRODUCTION === 'true';
    },

    get IS_MOBILE() {
        return window.innerWidth < 960;
    },

    get URLS() {
        return {
            APP_LOGIN: `${environment.APP_URL}/login`,
            APP_COURSES: `${environment.APP_URL}/home/cursos`,
            SITE_MOBILE_DISCLAIMER: `${environment.SITE_URL}/aprenda/assista-nossos-cursos-no-app`,
        };
    },

};
